import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { Button, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { useRoleContext } from "hooks";

interface DashboardBackButtonProps {
  onBeforeNavigate?: () => void;
}

export function DashboardBackButton({
  onBeforeNavigate = () => {},
}: DashboardBackButtonProps) {
  const navigate = useNavigate();
  const { role } = useRoleContext();

  const buttonText = role?.type === "CARRIER" ? "DASHBOARD" : "POST A SHIPMENT";

  const handleClick = () => {
    onBeforeNavigate();
    navigate("/");
  };

  return (
    <Button sx={{ justifyContent: "flex-start" }} onClick={handleClick}>
      <Stack direction="row" spacing={1}>
        <KeyboardBackspaceIcon />
        <Typography>{buttonText}</Typography>
      </Stack>
    </Button>
  );
}
